function Page() {
  return (
    <article id="9f97bb9b-e104-4bc6-ad4c-f55a0f17c7f5" className="page sans">
      <header>
        <h1 className="page-title">개인정보 처리방침</h1>
        <p className="page-description"></p>
      </header>
      <div className="page-body">
        <p id="ea66db45-0500-44e8-98b3-503cf5cd3d79" className="">
          이규호 만세력은 개인정보 보호법에 따라 정보주체의 개인정보를 보호하고
          이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여
          다음과 같이 개인정보 처리지침을 수립·공개합니다.
        </p>
        <ol
          type="1"
          id="b52d5e0f-6f9d-4ce7-a273-11774237f3ee"
          className="numbered-list"
          //start="1"
        >
          <li>
            개인정보의 수집 및 이용목적
            <br />
            회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다.
            <br />
            가. 서비스 기능 제공
            <br />
            콘텐츠 제공, 맞춤 서비스 제공
            <br />
            나. 회원 관리
            <br />
            회원제 서비스 제공, 개인 식별, 본인 확인에 의한 부정 이용 방지, 가입
            의사 확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록 보존,
            불만처리 등 민원처리, 고지사항 전달, 회원 탈퇴 의사의 확인
            <br />
            다. 신규 서비스 개발 및 통계적 분석, 마케팅 이벤트에 활용
            <br />
            신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스
            제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악, 회원의
            서비스이용에 대한 통계, 이벤트 정보 제공 및 참여기회 제공
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="ea5df47e-d216-47f0-afcd-3ce9e0aeacfc"
          className="numbered-list"
          //start="2"
        >
          <li>
            수집하는 개인 정보 항목 및 수집방법
            <br />
            회사는 회원가입, 원활한 고객상담, 서비스의 제공을 위해 회원가입 시
            및 서비스 이용 시 아래와 같은 개인정보를 수집하고 있습니다.
            <br />
            필수항목 : 닉네임, 이메일 주소(아이디), 비밀번호, 휴대전화번호
            <br />
            <p id="e6d515df-1e48-4a71-a102-3928e3c16396" className="">
              또한 서비스 이용과정이나 처리 과정에서 아래와 같은 정보들이
              자동으로 생성되어 수집될 수 있습니다.
              <br />
              수집내용 : PC웹, 모바일 웹/앱 이용 과정에서 단말기정보(OS,
              화면사이즈, 디바이스 아이디, 폰기종, 단말기 모델명), IP Address,
              쿠키, 방문 기록, 서비스 이용 기록, 불량 이용 기록
              <br />
            </p>
          </li>
        </ol>
        <p id="5733a72d-aff6-4517-a986-4b67bf8a7cd9" className=""></p>
        <ol
          type="1"
          id="fc3fed1f-cf66-4612-a1f7-70fd4208998a"
          className="numbered-list"
          //start="1"
        >
          <li>
            개인정보의 보유 및 이용 기간
            <br />
            회사는 이용자의 개인정보를 이용목적에 필요한 기간에만 제한적으로
            보유·이용합니다. 회사는 이용자가 개인정보의 수집 및 이용에 대한
            동의를 철회하거나 회원 탈퇴를 하는 경우, 사업을 종료하는 경우,
            개인정보의 수집 및 이용목적이 달성된 경우 해당 개인정보를 지체 없이
            파기합니다.
            <br />
            단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 법령에서
            정한 일정한 기간 동안 개인정보를 보관합니다.
            <br />
            계약 또는 청약철회 등에 관한 기록 : 5년
            <br />
            대금결제 및 재화 등의 공급에 관한 기록 : 5년
            <br />
            소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
            <br />
            통신사실확인자료 중 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료
            : 3개월
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="4c00b05c-2453-43cf-a845-ce1b1646ea46"
          className="numbered-list"
          //start="2"
        >
          <li>
            개인정보의 파기절차 및 파기방법
            <br />
            이용자의 개인정보는 원칙적으로 제3조에서 정한 보유 및 이용기간이
            종료된 경우 지체 없이 파기됩니다.
            <br />
            회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="2a4bbc6a-52a9-48bc-ba7e-2a6cd0982d13"
          className="numbered-list"
          //start="3"
        >
          <li>파기절차</li>
        </ol>
        <ul id="cce510e2-4abb-4049-99f5-0859618a038a" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            이용자의 개인정보는 제3조에서 정한 보유 및 이용기간이 종료된 경우
            파기됩니다. 단, 관련 법령에서 일정한 기간 동안의 보존을 요구하는
            경우, 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 관련 법령에서
            정한 기간동안 저장된 후 파기됩니다.
          </li>
        </ul>
        <ul id="99dfb8f6-2a6c-4c0c-bdb3-a348f936ec65" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            다만, 회원탈퇴 시에는 시스템 업데이트 소요시간으로 인해 탈퇴회원의
            정보가 파기되는 시간이 일정시간 소요될 수 있습니다.
          </li>
        </ul>
        <ol
          type="1"
          id="6429911b-3136-4748-927d-0568eb4815b9"
          className="numbered-list"
          //start="1"
        >
          <li>파기방법</li>
        </ol>
        <ul id="007eb4a2-d6ef-4679-b835-2c58c05a8777" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
            파기합니다.
          </li>
        </ul>
        <ul id="64378fc1-f6c3-4139-ac60-51b6160edee3" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
            방법을 사용하여 삭제합니다.
          </li>
        </ul>
        <ol
          type="1"
          id="c3c97870-ecb3-4b3a-93e8-fde866690097"
          className="numbered-list"
          //start="1"
        >
          <li>
            개인정보의 제공
            <br />
            회사는 이용자들의 개인정보를 제1조에서 고지한 범위 내에서 사용하며,
            이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로
            이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는
            예외로 합니다.
            <br />
            이용자가 개별적으로 제3자 제공에 대하여 사전 동의한 경우
            <br />
            법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에
            따라 수사기관의 요구가 있는 경우
            <br />
            영업의 전부 또는 일부를 양도하거나, 합병/상속 등으로 서비스제공자의
            권리, 의무를 이전 승계하는 경우
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="3f34bcd8-eacc-4854-9e26-da4dec293af1"
          className="numbered-list"
          //start="2"
        >
          <li>
            수집한 개인정보의 위탁 범위
            <br />
            회사는 서비스 향상을 위해서 아래와 같이 개인정보 취급업무를 위탁하고
            있습니다. 수탁업체와 위탁내용 보유개인정보의 내용은 아래와 같으며,
            단순 인증 및 전송처리는 별도의 정보를 보관하지 않습니다.
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="f5725559-8fb5-4a7d-8ebe-dde664464b73"
          className="numbered-list"
          //start="3"
        >
          <li>휴대전화번호 인증 서비스의 제공</li>
        </ol>
        <ul id="f7ebadfd-6b06-452c-8f8f-23e46e060c76" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            수탁자: 링크허브, 팝빌
          </li>
        </ul>
        <ul id="3dc76b70-dd93-4206-8ca0-18604518b90b" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            위탁업무: SMS 전송
          </li>
        </ul>
        <ol
          type="1"
          id="3a2175cd-f97a-4397-94db-d75cacebec2e"
          className="numbered-list"
          //start="1"
        >
          <li>정보 저장</li>
        </ol>
        <ul id="e6d671cc-0911-4a40-90e7-5453e60f94e0" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            수탁자: Amazon Web Services Inc.
          </li>
        </ul>
        <ul id="2bd5ef2b-8258-4b8f-8166-38db7c37917c" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            위탁업무: 클라우드 서버 운영 및 개인정보 보관(닉네임, 이메일
            주소(아이디), 비밀번호)
          </li>
        </ul>
        <ol
          type="1"
          id="6659892e-3a83-4ddf-9dac-3a76d2c42a4d"
          className="numbered-list"
          //start="1"
        >
          <li>이용자 및 법정대리인의 권리와 그 행사 방법</li>
        </ol>
        <ol
          type="1"
          id="2c4531c3-5c46-4b65-8473-c94425e26902"
          className="numbered-list"
          //start="2"
        >
          <li>
            이용자 및 만 14세 미만 아동의 법정 대리인은 언제든지 등록되어 있는
            자신 혹은 당해 아동의 개인정보를 조회하거나 수정할 수 있으며 회원
            탈퇴의 방법으로 정보 삭제 및 처리 정지를 요청할 수도 있습니다.
          </li>
        </ol>
        <ol
          type="1"
          id="36217b4c-c51e-4bef-9d1e-a64050e02d21"
          className="numbered-list"
          //start="3"
        >
          <li>
            이용자 혹은 만 14세 미만 아동의 법정대리인이 전 항의 권리행사를
            위하여 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하시면
            지체 없이 조치하겠습니다.
          </li>
        </ol>
        <ol
          type="1"
          id="b198c6a9-4667-497c-934f-7785895d6e2f"
          className="numbered-list"
          //start="4"
        >
          <li>
            전 항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
            대리인을 통하여 하실 수 있습니다. 단, 이 경우 개인정보 보호법
            시행규칙에 따른 위임장을 제출하셔야 합니다.
          </li>
        </ol>
        <ol
          type="1"
          id="a82c6668-72fc-4f82-ba94-cd14d2f89e98"
          className="numbered-list"
          //start="5"
        >
          <li>
            이용자의 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가
            수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
          </li>
        </ol>
        <ol
          type="1"
          id="31c123e3-d09a-4140-b768-b67d72f6fbc7"
          className="numbered-list"
          //start="6"
        >
          <li>
            회사는 이용자 권리에 따른 열람·정정·삭제 또는 처리정지의 요구 시
            열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
          </li>
        </ol>
        <ol
          type="1"
          id="ab3535fa-83a8-4477-bf44-f19568534038"
          className="numbered-list"
          //start="7"
        >
          <li>
            이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을
            완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
            잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를
            제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
          </li>
        </ol>
        <ol
          type="1"
          id="2f66319b-8455-4027-a918-cfb465e90bcb"
          className="numbered-list"
          //start="8"
        >
          <li>
            회사는 이용자 혹은 법정 대리인의 요청에 의해 삭제된 개인정보는
            개인정보 파기절차 및 파기방법에 명시된 바에 따라 처리하고 그 외의
            용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
          </li>
        </ol>
        <ol
          type="1"
          id="0f32ac06-1ac0-464e-8f9d-b951eec78e82"
          className="numbered-list"
          //start="9"
        >
          <li>
            개인정보의 안전성 확보조치에 관한 사항
            <br />
            회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
            있습니다.
            <br />
          </li>
        </ol>
        <p id="72e3aa43-1788-402b-a784-19d779d75b72" className="">
          기술적 조치 : 회원의 개인정보는 비밀번호에 의해 보호되며, 중요한
          데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금 기능을 사용하는
          등의 별도 보안기능을 통해 보호하고 있습니다.
          <br />
          관리적 조치 : 개인정보관련 취급 직원은 담당자에 한정시켜 최소화 하고
          개인정보보호 의무에 관해 정기적인 교육을 실시하며 접근 권한을 관리하는
          등 관리적 대책을 시행하고 있습니다.
          <br />
        </p>
        <ol
          type="1"
          id="9b5b009c-a199-4aa1-9a2b-db25f9b3aaa1"
          className="numbered-list"
          //start="1"
        >
          <li>
            개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
            <br />
            회사는 이용자의 접속 정보를 저장하고 수시로 불러오는 쿠키 및 그와
            유사한 기술을 사용합니다. 쿠키는 이용자가 어플리케이션 서비스를
            이용하거나 사이트를 방문하였을 때 이용자의 단말기에 저장되는 소량의
            정보이며, 이용자가 사이트를 재방문했을 때 읽을 수 있는 정보를
            저장합니다.
            <br />
          </li>
        </ol>
        <ol
          type="1"
          id="04249057-4456-41d2-95e3-376e6459bbf2"
          className="numbered-list"
          //start="2"
        >
          <li>쿠키의 사용 목적</li>
        </ol>
        <ul id="a8ff3cc3-904a-4a0f-9987-b6bc37624378" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            이용자의 접속 세션을 유지하기 위하여
          </li>
        </ul>
        <ul id="513a2e9c-01ef-47d3-8ce3-b3aa6b832bbd" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            이용자의 서비스 및 사이트에 대한 이용 및 방문 행태 분석을 위하여
          </li>
        </ul>
        <ul id="2abb0309-637f-4c0e-9f86-7cc72da80d61" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            보안 접속을 위하여
          </li>
        </ul>
        <ol
          type="1"
          id="353a2f7b-8c0f-4f72-8606-89d45ef47e19"
          className="numbered-list"
          //start="1"
        >
          <li>쿠키의 설치/운영 및 거부</li>
        </ol>
        <ul id="cd182f79-be4d-44bc-b850-7c75a2e684f3" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            이용자가 웹을 통해 서비스를 이용하는 경우 브라우저의 옵션을
            설정함으로써 모든 쿠키의 허용여부를 결정할 수 있습니다.
          </li>
        </ul>
        <ul id="9556777a-d78e-4e6c-9dad-2920e7072879" className="bulleted-list">
          <li
            style={{
              listStyleType: "disc",
            }}
          >
            쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스는 이용에
            어려움이 있을 수 있습니다.
          </li>
        </ul>
        <ol
          type="1"
          id="695fa651-6822-44a6-99a8-60554c5282d2"
          className="numbered-list"
          //start="1"
        >
          <li>
            개인정보 보호책임자
            <br />
            회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 요청은
            개인정보 보호책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는
            이용자의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
            <br />
          </li>
        </ol>
        <p id="2b1b5731-5f11-46d1-8c73-56cb3c1020dd" className="">
          &lt;개인정보 보호 책임자&gt;
          <br />
          성명 : 이규호
          <br />
          직급 : 대표이사
          <br />
          연락처 : <br />
          <a href="mailto:sss29549@gmail.com">sss29549@gmail.com</a>
        </p>
        <p id="130fc864-2073-45e6-8011-4c16f8d991f5" className=""></p>
        <p id="fdfa02b8-41bb-4882-becc-083674092727" className=""></p>
        <p id="6a052228-713a-4399-a93b-1ce21ec29a97" className="">
          개인정보 처리방침의 적용 및 변경
          <br />이 개인정보 처리방침은 2024년 01월 10일부터 적용됩니다.
          <br />
        </p>
      </div>
    </article>
  );
}

export default Page;
